import { chapterResources } from '../../../reducers/Chapter/Resource/resource.reducer';
import { chapterResourcesStore } from '../../../rootReducer';

export function selectChapterResources(state) {
    return state[chapterResourcesStore][chapterResources];
}
